import React, { useState } from "react";
import management1 from "../assets/image/management1.jpeg";
import management2 from "../assets/image/management2.jpg";
import management3 from "../assets/image/management3.jpeg";
import management4 from "../assets/image/management4.jpg" ;
const ManagementBoard = () => {
  const managementData = [
    {
      id: 0,
      title: "Prezident",
      desc: ` <strong>Turan Özbahçeci</strong>, İstanbulda 18 kvadratmetrlik kiçik bir
        marketlə başlayaraq, cəmi 12 il ərzində 52 supermarketə
        çataraq ilk uğurunu qazanmışdır. Daha sonra, bu marketlərin
        böyük bir qismini dünyanın ən böyük üç pərakəndə nəhəngindən
        biri olan İngiltərə mərkəzli Tescoya satmağı bacarmış və
        geridə qalan marketləri isə yerli bir şəbəkəyə təhvil verərək,
        bu layihəni uğurla tamamlamışdır. Bu ilk addım, Turan
        Özbahçecinin pərakəndə sahəsində mühüm bir uğur hekayəsi
        olmuşdur. Türkiyədəki pərakəndə sektorundakı fəaliyyətlərinə
        davam edərkən, İstanbul Pərakəndəçilər Dərnəyində 2 il sədr
        müavini, 2 il isə sədrolaraq çalışmışdır. Eyni zamanda,
        Pərakəndəçilər Dərnəyində 72 pərakəndə markasını bir araya
        gətirərək Fayda Mağazacılıq Anonim Şirkətini də məhz Turan
        Özbahçeci qrurmuşdur. Burada, “Saf və Nefis” markalı
        məhsullarla və bir çox xüsusi layihələrlə, yerli
        pərakəndəçilərin beynəlxalq oyunçularla rəqabət aparmasını
        təmin etmiş və Türkiyə Pərakəndəçilər Federasiyası sədr
        müavini vəzifəsini də uzun müddət icra etmişdir.
       <br/> <br/>  
       2008-ci ildə
        başladığı və hələ də 2024-cü ildə davam edən “Yerel Zincirler
        Buluşuyor” konfransının isim babası və qurucusu olmuşdur. Bu
        layihə, yerli pərakəndəçilərin bir araya gələrək təcrübələrini
        paylaşmalarını və yeni yəməkdaşlıqlar qurmalarını
        hədəfləmişdir. Ənənəvi düşüncələri dəyişən layihələr arasında
        Port Baku Ticarət Mərkəzində Portpazar mağazasının fəaliyyətə
        başlaması da başda yer alır. Mağaza, sadəcə 3 ay ərzində, 18
        sentyabr 2010-da möhtəşəm bir açılışla fəaliyyətə başladı və
        hələ də Azərbaycanın ən mühüm pərakəndə layihələrindən biri
        olaraq davam edir. Bu layihə, Başdan sona Özbahçeci Layihəsi
        çərçivəsində həyata keçirilmişdir. Azərbaycanda, 2010-cu ildə
        qurulan və bu gün ölkənin ən böyük market şəbəkəsi olan Araz
        Supermarketlərinin qurucu ortaqlarından biri də Turan
        Özbahçecidir. Şirkətin ilk rəhbəri olaraq, Araz marketlərinin
        yaradılmasını həyata keçirmiş və “Ardaş Azərbaycan” şüarı ilə
        markanı inkişaf etdirmişdir.
        <br/> <br/>  
         Bu layihə, Özbahçecinin ən mühüm
        təşəbbüslərindən biridir və bu gün Azərbaycan bazarında bir
        nömrədir. Azərbaycanın məhsullarını dünya bazarına çıxarmaq
        missiyası ilə Dubay və Dohada Azərbaycan Ticarət Evi
        layihələrini həyata keçirmişdir. Bu layihələrlə, əlliyə yaxın
        müəssisənin və fabrikin məhsullarını dünya bazarına çıxararaq
        Azərbaycan ixracı böyük həcmdə artmışdır. Uşaq bezi istehsalı
        ilə məşğul olan bir fabrik satın alaraq, çox qısa müddətdə
        Azərbaycanın ən mühüm uşaq bezi markalarından biri olan
        “Miniboss” markalı uşaq bezlərini və “Lalona” markalı kağız
        məhsullarını bazara çıxarmışdı. Bu gün bu fabrik, 24/7
        işləyərək Özbəkistan başda olmaqla bir çox ölkəyə ixrac edir.
        Gloria Jeans Coffee ilə qlobal bir əməkdaşlıq quraraq, əvvəl
        Rusiyada, sonra Ukraynada, İstanbulda, Monteneqroda, Polşada
        və Özbəkistanda Gloria Jeans Coffee master françayzlarını
        almış və bu ölkələrdə böyüməni təşkil etmişdir. Bu iş birliyi
        hələ də beş ölkədə davam edir. 2015-ci ildə 12 şirkətin bir
        mərkəzdən idarə olunması üçün mərkəzi Dubayda Yerləşən TAAC
        DMCC şirkətinin qurucu ortağı olmuşdur. 2014-cü ildə
        Azərbaycanın ən mühüm un məmulatları fabriki olan “Azcake”ı
        qurmuşdur. Bu gün 1200 işçisi ilə bazarın ən mühüm un
        məmulatları fabriki olmuşdur. 
        <br/> <br/>  
        Eyni zamanda, Qarabağın azad
        edilməsindən sonra, bu bölgədə ilk iş fəaliyyətini Azcake
        Çörək Zavodunu quraraq həyata keçirmişdir. Dünyanın bir çox
        yerində fəaliyyət göstərən Özbahçeci, Bolqarıstanda yaxın
        zamanda bir yaş salfet fabriki qurmuş və bu fabrikdən
        Avropanın bir çox ölkəsinə ixracata başlamışdır. Gənclərə
        dəstək vermək məqsədilə bir YouTube kanalı quraraq, burada
        ənənələri dəyişən təlimlər təklif edən bir platform
        yaratmışdır. Bu platformda, “Üşənmə, ertələmə, vazkeçmə”
        prinsipləri ilə gənclərə yönələn məzmunlar hazırlayır və hər
        həftə müntəzəm təlimlər verərək izləyicilərini
        maarifləndirməyə dəvam edir.. Beynəlxalq layihələrdən biri
        olan Özbahçeci Invest Club-ı dörd dostu ilə birgə qurmuş və
        hər gün böyüyən bir biznes modelə çevrilmişdir.Yüzlərlə
        layihələrə dəstək verilərək ölkədə yeni bir investisiya modeli
        yaratmışdır. Bu klub, gənclərin fikirlərini, yaxşı rəhbərlər
        və investorlarla bir araya gətirib, dünya markalarını
        yaratmağa davam edəcəkdir. Turan Özbahceci təkcə yaxşı rəhbər
        deyil, sözün əsl mənasında LİDERDİR.`,
      img: management1,
    },
    {
      id: 1,
      title: "Vitse-Prezident",
      desc: `<strong>Nəzrin Sadıxova</strong> biznes fəaliyyətinə 2005-ci ildən başlamışdır. O, İsveçrə saatları və zərgərlik məmulatlarının rəsmi təmsilçsi olan İsveçrənin Swiss House şirkətinin sahibi olmuşdur.
        Nüfuzlu sahibkar xanım kimi, İsveçrədə uzun müddətyaşayaraq, Avropanın bir çox biznes layihələrinə qatılaraq, böyük nailiyyətlər qazanmış və müvafiq sertifikat və mükafatlarla təltif edilmişdir. Belə ki ilin ən uğurlu şirkəti, uğurlu sahibkar qadin,BALMAİN şirkətinin şərqi Avropadaki ən uğurlu rəsmi nümayəndəsi kimi mükafatlarla təltif olunmuşdur.
         <br/> <br/>
        Həmçinin, Nəzrin Sadıxova London Beynəlxalq Biznesməktəbinin Beynəlxalq Biznesin İdarəedilməsi ixtisasıüzrə diplomuna malikdir.
         
        2016-ci ildən Bakıda, Gəncədə və Şəmkirdə yerləşənüç klinika daxil olan “Spektr Medical Group” şirkətlər qrupunun idarə heyətinin sədridir.
         
        Uzun illərdir ki “SABAH” humanitar təşkilatına rəhbərlik edir. Bu təşkilatın məqsədi
        fiziki və əqli imkanları  məhdud olan, valideynlərini itirmiş xəstə və əlil uşaqlara humanitar yardım göstərməkdir.  
        <br/> <br/>
        2022-ci ildə Azərbaycanda biznes klubu olan “Global Association of Business People of Azerbaijan”(GABA) şirkətini təsis etmişdir. Bu şirkət sahibkarlarıbir araya gətirərək onların işgüzar münasibətlərinin daha da şaxələnməsinə və güclənməsinə dəstək olur.
         
        Həmçinin, startap layihələrə və gənc sahibkarlara fəalşəkildə dəstək verir.
        Eyni zamanda “InterFest”, “Uğura Doğru”, kimsəsiz uşaqlar üçün xeyriyyə layihələri  “İstedadlı Sabahlar” kimi iri layihələrin rəhbəri və təşkilatçısıdır.
         
        Hal- hazırda  Nəzrin Sadıxova yeni innovativ texnoloqiyaların tətbiqi ilə məşquldur.  Nəzrin xanim ilk dəfə olaraq Azərbaycanda istehsal olunan məhsulların onlayn Shoppingaz.az platformasını yaratmışdır və bununla da Azərbaycan brendlərinin dünyada tanınmasını təmin etmişdir.`,
      img: management2,
    },
    {
      id: 2,
      title: "İnvest Club Danışmanı",
      desc: `<strong>Doğan Tomris </strong>36 ildir ki, restoran və xidmət sənayesində böyük həvəslə çalışır. Uzun illər McDonald’s-ın Türkiyədəki əməliyyatlarında çalışdıqdan sonra 25 ildir Rusiya, Azərbaycan, Gürcüstan və region ölkələrində ilk günün həyəcanı ilə işləyir.  Ticarət mərkəzinin idarə edilməsi, sıfırdan restoran sənayesinin qurulması və açılması, brendin yenilənməsi, françayzinq sisteminin qurulması, françayzinq əldə edilməsi və startap konsultasiyası onun təcrübə sahələridir. <br/> <br/> Biliklərini bölüşmək üçün müxtəlif qeyri-hökumət təşkilatlarında iştirak edir. Azərbaycan Sahibkarlar Konfederasiyasının restoran xidmətləri komissiyasının təsisçisidir. Azərbaycan Françayzinq Assosiasiyasında məsləhətçi vəzifəsində çalışır. O, Akiab və digər iş adamlarının təşkilatlarını təlim və təşkilat meneceri kimi dəstəkləyir.`,
      img: management3,
    },
    {
        id:3,
        title:"İnvest Komitə Müdürü",
        desc:`<strong>Kamil Bağırov</strong> CraZzy Bear konseptual restoranının sahibi və təsisçisidir. CraZzy Family şirkətləri CraZzy Bear restoranı ilə yanaşı CraZzy Chameleon, CraZzy Mosquito, CraZzy Gifts, CraZzy Partners, CraZzy Aghabala Chaykofski və digər məkanları özündə birləşdirir. Kamilin məqsədi Azərbaycanı dünyada konseptual restoranların əmələ gəldiyi bir ölkə kimi tanıtmaq və ölkənin bu sahədəki nüfuzunu gücləndirməkdir.`,
        img:management4
    }
  ];

  const [showMoreIndex, setShowMoreIndex] = useState({});

  const handleShowMore = (index) => {
    setShowMoreIndex((prevState) => ({
      ...prevState,
      [index]: (prevState[index] || 1800) + 800, 
    }));
  };
  return (
    <>
    <section className="management ">
        <h2 className="title fz-48 text-center my-5">
          İnvest Club <span>İdarə heyətimiz</span>
        </h2>
        <div className="container">
          <div className="row g-3">
            {managementData.map((item, index) => {
        
              const showMore = showMoreIndex[index] || 1800; 

              return (
                <div className="row g-3" key={index}>
                  <div
                    className={index % 2 === 0 ? "col-lg-6 col-sm-12 col-12" : "col-lg-6 col-sm-12 col-12 order-2"}
                    data-aos="fade-up"
                  >
                    <div className="managementDesc">
                      <h2 className="title fz-40 my-5">{item.title}</h2>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.desc.slice(0, showMore),
                        }}
                      />
                      {showMore < item.desc.length && (
                        <a
                          onClick={() => handleShowMore(index)}
                          className="link link-lg pb-5"
                        >
                          <mark>Daha çox oxu</mark>
                        </a>
                      )}
                    </div>
                  </div>
                  <div
                    className={index % 2 === 0 ? "col-lg-6 col-sm-12 col-12" : "col-lg-6 col-sm-12 col-12 order-1"}
                    data-aos="fade-up"
                  >
                    <img
                      src={item.img}
                      alt={item.title}
                      className="img-fluid"
                      style={{ position: "sticky", top: "0" }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ManagementBoard;
